import React from "react";
import "../styles/home.css";
import Logobar from "./mailbox/Logobar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ColorStore from "../reduxContainer/ColorStore";

const Home = () => {
  const themeColor = useSelector((state) => state.themeColor);
  const themeSupportingColor = ColorStore[themeColor];

  return (
    <>
      <div className="home_container" style={{ '--theme-color': themeColor, '--theme-supporting-color': themeSupportingColor }}>
        <Logobar />
        <Outlet />
      </div>
    </>
  );
};

export default Home;
